export class LinearMultiSelector {
    private readonly onChange: () => void;
    private inputs: HTMLInputElement[];

    public constructor(linearMultiSelectorHtml: HTMLElement, onChange: () => void = () => {}) {
        this.onChange = onChange;
        if (linearMultiSelectorHtml) {
            this.inputs = Array.from(linearMultiSelectorHtml.querySelectorAll(".js-wl-linear-multi-selector-filter-input")) as HTMLInputElement[]
            this.whenClicked(this.inputs, (input) => {
                this.inputClicked(input);
            });
        } else {
            this.inputs = [] as HTMLInputElement[];
        }
    }

    private whenClicked(inputs: HTMLInputElement[], callback: (input: HTMLInputElement) => void) {
        inputs.forEach((input: HTMLInputElement) => {
            input.addEventListener('click', () => callback(input))
        })
    }

    private inputClicked(input: HTMLInputElement) {
        this.checkOtherCheckboxes(input);
        this.onChange();
    }

    private checkOtherCheckboxes(input: HTMLInputElement) {
        this.checkCheckboxes(this.checkboxesToCheck(input));
    }

    private checkboxesToCheck(input: HTMLInputElement | null) {
        const selectedValues = this.checkedValues();
        if (input && selectedValues.length == 1 && selectedValues[0] == input.value) {
            let valuesToCheck = [0]
            for(let i = parseInt(input.value)+1; i < 6; i++) {
                valuesToCheck.push(i);
            }
            return valuesToCheck;
        } else {
            return [];
        }
    }

    private checkedValues() {
        return this.inputs
            .filter((input) => input.checked)
            .map((input) => input.value || "");
    }

    private checkCheckboxes(valuesToCheck: number[]) {
        if (valuesToCheck.length == 0) return;

        this.inputs.forEach((input: HTMLInputElement) => {
            if (valuesToCheck.includes(parseInt(input.value))) {
                input.checked = true;
            }
        });
    }
}
